<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-06-20 17:18:12
 * @LastEditTime: 2019-08-22 11:00:26
 * @LastEditors: Please set LastEditors
 -->
<template>
  <div class="login" ref="login" :style="background">
    <div class="loginBox">
      <div class="head">
        <div class="login">
          <img :src="logos.img_url" alt />
          {{logos.vendorname}}
        </div>
        <div class="tips"></div>
      </div>
      <div class="admin_head">——经销商登陆</div>
      <div class="body">
        <el-form ref="form" :rules="rules" :model="form" label-width="80px">
          <el-form-item prop="name">
            <el-input placeholder="请输入账号" prefix-icon="el-icon-user" v-model="form.username "></el-input>
          </el-form-item>
          <el-form-item prop="password">
            <el-input
              placeholder="请输入密码"
              prefix-icon="el-icon-unlock"
              show-password
              v-model="form.password"
            ></el-input>
          </el-form-item>
          <el-form-item prop="verify_code">
            <div class="code clearfix">
              <el-input placeholder="请输入验证码" prefix-icon="el-icon-date" v-model="form.verify_code"></el-input>

              <div @click="getVerify" class="Verify">
                <img :src="verify.verify_img" alt />
              </div>
            </div>
          </el-form-item>
          <el-form-item>
            <div class="code rember clearfix">
              <div>
                <el-checkbox v-model="checked">记住密码</el-checkbox>
              </div>
              <div class="forget" @click="forget">忘记密码?</div>
            </div>
          </el-form-item>
          <el-form-item>
            <el-button @click="login('form')">登录</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="foot">© 2010-2018 {{logos.companyname}}</div>
  </div>
</template>

<script>
import identify from "@/components/identify/identify";
import { error } from "util";
export default {
  name: "login",
  data() {
    let code = (rule, value, callback) => {

      if (value != this.identifyCode) {
        callback(new Error("验证码错误"));
      } else {
        callback();
      }
    };
    return {
      backgroundIndex: Math.ceil(Math.random() * 6),
      background: {
        backgroundImage: ""
      },
      form: {
        username: "",
        password: "",
        verify_code: ""
      },
      checked: false,
      verify: {},
      rules: {
        username: [
          { required: true, message: "请输入账号信息", trigger: "blur" }
        ],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
        verify_code: [
          { required: true, message: "请输入验证码", trigger: "blur" }
        ]
      },
      logos:{}
    };
  },
  components: {
    identify
  },
  mounted() {
    this.init();
    this.getOem()
  },
  methods: {
    getOem(){
               // 获取OEM品牌商图片
          this.$get("logistics_1", "/vendor/logo", {
            customer_id:sessionStorage.getItem('customer_id'),
            lan:'zh-CN'
          })
            .then(res => {
                this.logos=res.data
            })
            .catch(error => {
              // console.log(error);
            });

    },
    init() {
      this.background.backgroundImage = `url(${require("../../assets/img/" +
        this.backgroundIndex +
        ".png")})`; //动态背景图
      //  读取忘记密码的数据
      if (sessionStorage.getItem("userInfo")) {
        this.form.name = JSON.parse(sessionStorage.getItem("userInfo")).name;
        this.form.password = JSON.parse(
          sessionStorage.getItem("userInfo")
        ).password;
      }
            // 获取默认接口权限
          this.$post("login", "/client", {
            client_id: this.$base.client_id,
            client_secret: this.$base.client_secret
          })
            .then(res => {
              localStorage.setItem(
                "access_token",res.data.access_token);

            //   获取验证码
                    this.getVerify();
            })
            .catch(error => {
              // console.log(error);
            });

    },
    // 获取验证码
    getVerify() {
      this.$get("logistics", "/login.verify").then(res => {
        this.verify = res.data;
      });
    },
    // 忘记密码
    forget() {
      this.$alert("请联系客服处理！", "", {
        confirmButtonText: "确定"
      });
    },
    // 登陆
    login(form) {
      this.$refs[form].validate(valid => {
        if (valid) {
          if (this.checked) {
            sessionStorage.setItem("userInfo", JSON.stringify(this.form));
          }
              // 获取权限成功  调用登陆接口
              
                this.$post("logistics", "/login", {
                    verify_code:this.form.verify_code,
                    password:this.form.password,
               username:this.form.username+'@'+sessionStorage.getItem("customer_id"),
                verify_id: this.verify.verify_id,
                client_id: this.$base.client_id,
                client_secret: this.$base.client_secret,
                login_type:3
              })
                .then(res => {
                  this.$message(res.message);
                  var _this = this;
                      localStorage.setItem("access_token",res.data.access_token)
                  setTimeout(() => {
                    _this.$router.push("/");
                  }, 500);
               
                })
                .catch(error => {
                  this.$message.error(error.message);
                });
        } else {
          this.$alert("请输入完所有信息", "", {
            confirmButtonText: "确定"
          });
          return false;
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.login {
  background-color: #fff;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-size: 100%;
  background-repeat: no-repeat;
  img{
    width: 42px;
  }
  /deep/ .el-form-item__content {
    margin: 0 !important;
  }
  .loginBox {
    width: 475px;
    box-sizing: border-box;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.4), 0 0 150px rgba(0, 0, 0, 0.4);
    border-radius: 4px;
    position: absolute;
    top: 46%;
    left: 50%;
    margin-top: -209px;
    margin-left: -214px;
    z-index: 100;
    .head {
      position: absolute;
      top: 0;
      text-align: center;
      width: 100%;

      .login {
        text-align: center;
        font-size: 30px;
        width: 100%;
        padding-top: 30px;
        color: #fff;
        -webkit-box-reflect: below 5px -webkit-gradient(linear, left top, left
              bottom, from(transparent), to(rgba(255, 255, 255, 0.2)));
        background-image: -webkit-linear-gradient(92deg, #fff, #1c97f5);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        -webkit-animation: hue 6s 100 linear;
        letter-spacing: 2px;
        img {
          vertical-align: middle;
        }
      }
      .tips {
        text-align: right;
        font-size: 14px;
        color: #f2f2f2;
        padding-right: 14px;
        margin-top: 70px;
        font-weight: 400;
      }
    }
    .admin_head {
      height: 150px;
      text-align: right;
      color: #fff;
      vertical-align: bottom;
      line-height: 270px;
      padding-right: 20px;
      font-size: 15px;
    }
    .body {
      position: relative;
      padding: 50px 60px;
      background: #fff;
      background: rgba(255, 255, 255, 0.8);
      border-bottom-left-radius: 3px;
      border-bottom-right-radius: 3px;
      text-align: center;
    }
  }
}
.el-form {
  > div {
    margin-bottom: 10px;
  }
  .code {
    > div {
      float: left;
      width: 59%;
    }
    > div:last-child {
      float: right;
      width: 40%;
    }
    .Verify {
      img {
        width: 100%;
        height: 40px;
      }
    }
  }
}
.rember {
  div {
    width: auto !important;
  }
}
.forget {
  cursor: pointer;
  color: #3c9bed;
  font-size: 14px;
}
.el-button {
  display: block;
  height: 38px;
  line-height: 38px;
  width: 100%;
  padding: 0 18px;
  color: #fff;
  white-space: nowrap;
  text-align: center;
  font-size: 14px;
  border: none;
  border-radius: 2px;
  cursor: pointer;
  background-color: #3c9bed;
  border-radius: 5px;
  height: 50px;
  font-size: 20px;
}
.foot {
  color: #eee;
  position: fixed;
  bottom: 0;
  text-align: center;
  width: 100%;
  background: rgba(0, 0, 0, 0.1);
  padding: 10px;
  z-index: 1;
}
</style>
